export default "__VITE_ASSET__w9fzgMfD__"